export const pvt_lmt_registration = [
  {
    ip1: "कम्पनी रहने ठेगाना",
    type: "text",
    name: "company_address",
    validation: {
      required: {
        value: true,
        message: "this field is mandatory",
      },
    },
  },
  {
    ip1: "सम्बन्धित ब्यक्तीको नाम",
    type: "text",
    name: "related_person",
    validation: {
      required: {
        value: true,
        message: "this field is mandatory",
      },
    },
  },
  {
    ip1: " सम्बन्धित ब्यक्तीको सम्पर्क नं.",
    type: "number",
    name: "total_expense",
    validation: {
      required: {
        value: true,
        message: "this field is mandatory",
      },
    },
  },
  {
    ip1: " कम्पनीको प्रकार",
  },

  {
    ip1: " जम्मा शेयर सदस्य संख्या",
    type: "number",
    name: "total_shareholders",
    validation: {
      required: {
        value: true,
        message: "this field is mandatory",
      },
    },
  },
  {
    ip1: "  अधिकृत पुँजी",
    type: "number",
    name: "total_capital",
    validation: {
      required: {
        value: true,
        message: "this field is mandatory",
      },
    },
  },
  {
    ip1: " जारी तथा चुक्ता पुँजी",
    type: "number",
    name: "paid_capital",
    validation: {
      required: {
        value: true,
        message: "this field is mandatory",
      },
    },
  },
 
];

export const pvt_details_of_shareholder = [
  {
    ip1: "क्र. स.",
    // type: "text",
    name: "s.no",
  },
  {
    ip1: " शेयर सदस्यहरुको नाम",
    type: "text",
    name: "name",
    validation: {
      required: {
        value: true,
        message: "this field is mandatory",
      },
    },
  },
  {
    ip1: "  हालको ठेगाना",
    type: "text",
    name: "address",
    validation: {
      required: {
        value: true,
        message: "this field is mandatory",
      },
    },
  },

  {
    ip1: " शेयर रकम",
    type: "number",
    name: "share_amount",
    validation: {
      required: {
        value: true,
        message: "this field is mandatory",
      },
    },
  },
  {
    ip1: "शेयर सदस्यको नागरिकता",
    type: "file",
    name: "citizenship",
    validation: {
      required: {
        value: true,
        message: "this field is mandatory",
      },
    },
  },
  {
    ip1: " साँक्षीको नाम",
    type: "text",
    name: "witness_name",
    validation: {
      required: {
        value: true,
        message: "this field is mandatory",
      },
    },
  },
  {
    ip1: "साँक्षीको ठेगाना",
    type: "text",
    name: "witness_address",
    validation: {
      required: {
        value: true,
        message: "this field is mandatory",
      },
    },
  },
  {
    ip1: " साँक्षीको नागरिकता",
    type: "file",
    name: "witness_citizenship",
    validation: {
      required: {
        value: true,
        message: "this field is mandatory",
      },
    },
  },
];


export const private_shareholder =  pvt_details_of_shareholder.filter(item=> item.name !=="s.no").reduce((a,v)=>({...a, [v.name]:""}),{})
